var _rect, _rect2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnonNoun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D5D7E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_1881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D5D7E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_1881)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 12,
    y: 12,
    width: 20,
    height: 15,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 7,
    height: 7,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 7,
    height: 7,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 3,
    height: 1,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 4,
    height: 1,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 1,
    height: 3,
    fill: "#868A9B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 14,
    y: 30,
    width: 16,
    height: 19,
    fill: "#868A9B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonNoun);
export default __webpack_public_path__ + "static/media/anonNoun.d7a15964ad173adce9344cb0c41eef27.svg";
export { ForwardRef as ReactComponent };